import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Checkbox from "@amzn/meridian/checkbox";
import ControlGroup from "@amzn/meridian/control-group";
import {optionsAddedOrChanged} from "../../actions/OptionsActions";
import {FormattedMessage} from "react-intl";

class AssociateStatusOptions extends Component {
    render() {

        const {selectedStatuses} = this.props;
        return (
            <ControlGroup label={<FormattedMessage id="associateStatusOption.active" defaultMessage="Active"/>}
                          onChange={updatedStatuses => this.handleStatusesChange(updatedStatuses)} value={selectedStatuses}>
                <Checkbox data-cy={"associateStatusFieldsetOption"} key="Yes" value="Yes">
                    <FormattedMessage id="associateStatusOptions.yes" defaultMessage="Yes"/>
                </Checkbox>
                <Checkbox data-cy={"associateStatusFieldsetOption"} key="No" value="No">
                    <FormattedMessage id="associateStatusOption.no" defaultMessage="No"/>
                </Checkbox>
            </ControlGroup>
        )
    }

    handleStatusesChange(updatedStatuses) {
        this.props.dispatch(optionsAddedOrChanged(
            {
                'associateStatuses': updatedStatuses
            }))
    }
}

const mapStateToProps = state => ({
    selectedStatuses: state.optionsReducer.options.associateStatuses
});
export default withRouter(connect(mapStateToProps)(AssociateStatusOptions));


// WEBPACK FOOTER //
// ./src/components/options/AssociateStatusOptions.js